// src/lib/broschueren.js
// -----------------------------------------------------------------------------
// Die Fachbroschueren von etb-karlsruhe.de (Downloadbereich) und die Regel,
// wann eine davon zum Wartungsbericht passt.
//
// Von Anna-Lena am 04.09.2026 bestaetigt ("broschüre passt"). Aendern laesst
// sich die Zuordnung jederzeit - dafuer reicht diese eine Datei.
//
// Die uebrigen 14 Broschueren (Kabelmesswagen, PowerBoxx, Rufbereitschaft,
// Betriebsfuehrungsvertrag, Stellungnahme E.8 ...) sind Vertriebsunterlagen
// und bewusst keiner Regel zugeordnet.
//
// Wann greift eine Regel?
//   modul     Code der Modul-Vorlage, irgendein Punkt darin ist n.i.O.
//   pos       genaue Positionsnummern, die n.i.O. sind
//   praefix   alles, was mit dieser Nummer beginnt
//   immer     wird jedem Bericht beigelegt
//   config    Funktion auf der Stationskonfiguration (z. B. Isolierart Luft)
// -----------------------------------------------------------------------------
// Mit .js: die Pruefskripte in werkzeuge/ laden diese Datei direkt mit Node.
import { LUEFTUNG_GRUENDE, passtZuGrund } from './pruefpunktLogik.js';

const CDN = 'https://cdn.shopify.com/s/files/1/0914/1580/6325/files/';

export const BROSCHUEREN = [
  {
    nr: '06', titel: 'Inspektion und Wartung von Trafostationen',
    datei: CDN + '07_Inspektion_Wartung_Trafostationen.pdf',
    immer: true,
  },
  {
    nr: '08', titel: 'Lebensdauer elektrischer Betriebsmittel',
    datei: CDN + '09_Lebensdauer_elektrischer_Betriebsmittel.pdf',
    pos: ['02.12', '03.3'],
  },
  {
    nr: '15', titel: 'Sicherheitstechnisches Zubehör in Transformatorstationen',
    datei: CDN + '18_Sicherheitstechnisches_Zubehoer_in_Transformatorstationen.pdf',
    modul: '05-SICHERHEITS-ZUBEHOER',
  },
  {
    nr: '12', titel: 'Ölwanne für Transformatoren',
    datei: CDN + '14_Oelwanne_fuer_Transformatoren.pdf',
    modul: '05-OEL-WANNE',
  },
  {
    nr: '16', titel: 'Störlichtbogenprüfung',
    datei: CDN + '19_Stoerlichtbogenpruefung.pdf',
    praefix: ['01.6.'],
  },
  {
    nr: '02', titel: 'Druckberechnung für Trafostationen',
    datei: CDN + '02_Druckberechnung_fuer_Trafostationen.pdf',
    pos: ['01.5.10', '01.5.11'],
    grundPos: { '01.5': { gruende: ['Entlastungsweg verdeckt', 'Verformung (Druckauslösung)'] } },
  },
  {
    nr: '18', titel: 'Thermische Belastung in Trafostationen',
    datei: CDN + '21_Thermische_Belastung_in_Trafostationen.pdf',
    praefix: ['01.5.'], modul: '07-ELEKTROTHERMOGRAFIE',
    grundPos: { '01.5': { gruende: LUEFTUNG_GRUENDE, auchOhneGrund: true } },
  },
  {
    nr: '21', titel: 'Trafowarnbalken in Transformatorstationen',
    datei: CDN + '24_Trafowarnbalken_in_Transformatorstationen.pdf',
    pos: ['04.4', '04.5'],
  },
  {
    nr: '05', titel: 'Hochspannungsschutzerde, Niederspannungsbetriebserde und Potentialsteuerung',
    datei: CDN + '05_Hochspannungsschutzerde_HSE_Niederspannungsbetriebserde_NBE_und_Potentialsteuerung_Schrittspannungserde_bei_Trafostationen.pdf',
    modul: '06-ERDERANLAGE',
  },
  {
    nr: '04', titel: 'Erdung der Schirmdrähte von Mittelspannungskabeln',
    datei: CDN + '04_Erdung_Schirmdraehte_von_Mittelspannungskabeln.pdf',
    pos: ['04.9'],
  },
  {
    nr: '19', titel: 'Trafolaufschienen in Trafostationen',
    datei: CDN + '22_Trafolaufschienen_in_Trafostationen.pdf',
    pos: ['04.8'],
  },
  {
    nr: '11', titel: 'Öl-, Gießharz- und Trockentransformatoren',
    datei: CDN + '13_Oeltransformatoren_Giessharztransformatoren_und_Trockentransformatoren.pdf',
    pos: ['04.7'],
  },
  {
    nr: '01', titel: 'Betrieb von Mittelspannungsschaltanlagen in offener Bauweise',
    datei: CDN + '01_Betrieb_von_Mittelspannungsschaltanlagen_in_offener_Bauweise.pdf',
    // Nur die OFFENE Bauweise, nicht jede luftisolierte Anlage.
    config: (c) => c?.ms_anlage_isolierart === 'luft_offen',
  },
];

// --- Lebensdauer ------------------------------------------------------------
//
// Zahlen aus der eigenen Broschuere 08 "Lebensdauer elektrischer Betriebsmittel"
// (Downloadbereich etb-karlsruhe.de), Tabelle AMEV/VDI/HEA:
//     Transformatoren (MS)        30 Jahre
//     MS-Schaltanlagen         25-30 Jahre
//     NS-Verteilungen          20-25 Jahre
// Die Zusammenfassung der Broschuere nennt pauschal "25-30 Jahre je nach
// Betriebsmittel" und empfiehlt: "Ab Jahr 20 sollte eine Zustandsbewertung und
// Budgetplanung beginnen."
//
// ETB rechnet bewusst mit dem unteren Wert (25 Jahre) - so wird der Kunde eher
// zu frueh als zu spaet informiert. Anna-Lena am 04.09.2026: "in der Regel sind
// es 25 Jahre Lebensdauer fuer alle Anlagenteile, Gebaeude wuerde ich nicht
// beachten."
// Seit 18.09.2026 nach der Tabelle AMEV/VDI/HEA (Anna-Lena): Trafo und
// MS-Schaltanlage 30 Jahre, NS-Verteilung 25 Jahre (USV/Notstrom 20 - nicht in der App).
export const LEBENSDAUER_JAHRE = {
  trafo: 30,
  ms_anlage: 30,
  nshv: 25,
};
// Ab diesem Alter geht die Broschuere mit: Zeit fuer Zustandsbewertung.
export const ZUSTANDSBEWERTUNG_AB_JAHREN = 20;

// Wie alt sind die Betriebsmittel dieser Station?
//   ueberschritten  - Lebensdauer ist rum
//   bald            - im naechsten Jahr erreicht
//   bewertung       - aelter als 20 Jahre, Zustandsbewertung empfohlen
export function lebensdauerBefund(config, trafos, msFelder, jahr = new Date().getFullYear()) {
  const posten = [];

  const pruefe = (was, bezeichnung, baujahr, grenze) => {
    if (!baujahr || baujahr < 1900 || baujahr > jahr) return;
    const alter = jahr - baujahr;
    if (alter >= grenze) posten.push({ was, bezeichnung, baujahr, alter, stufe: 'ueberschritten' });
    else if (alter >= grenze - 1) posten.push({ was, bezeichnung, baujahr, alter, stufe: 'bald' });
    else if (alter >= ZUSTANDSBEWERTUNG_AB_JAHREN) posten.push({ was, bezeichnung, baujahr, alter, stufe: 'bewertung' });
  };

  (trafos || []).filter(t => t.active !== false).forEach(t =>
    pruefe('trafo', t.bezeichnung || 'Transformator', t.herstellungsjahr, LEBENSDAUER_JAHRE.trafo));

  // Die MS-Anlage hat kein eigenes Baujahr an der Station; das aelteste Feld
  // gibt den Ausschlag.
  const feldJahre = (msFelder || []).map(f => f.herstellungsjahr).filter(Boolean);
  if (feldJahre.length) {
    pruefe('ms_anlage', 'Mittelspannungsanlage', Math.min(...feldJahre), LEBENSDAUER_JAHRE.ms_anlage);
  }

  const rang = { ueberschritten: 3, bald: 2, bewertung: 1 };
  const schlimmste = posten.reduce((m, p) => (rang[p.stufe] > rang[m] ? p.stufe : m), null);
  return { posten, schlimmste, etwasGefunden: posten.length > 0 };
}

// Liefert die Broschueren, die zu diesem Protokoll passen.
// alterBefund (optional): Ergebnis von lebensdauerBefund(). Ist etwas dabei,
// kommt die Lebensdauer-Broschuere mit - auch ohne Mangel im Protokoll.
export function passendeBroschueren(pruefpunkte, config, alterBefund) {
  const code = (pp) => pp?.protokoll_module?.modul_vorlagen?.code
    || pp?.modul_code || '';
  const nichtOk = (pruefpunkte || []).filter(pp => pp.in_ordnung === false);

  return BROSCHUEREN.filter(b => {
    if (b.immer) return true;
    if (b.nr === '08' && alterBefund?.etwasGefunden) return true;
    if (b.config && b.config(config)) return true;
    return nichtOk.some(pp => {
      const nr = pp.pos_nummer || '';
      if (b.modul && code(pp) === b.modul) return true;
      if (b.pos && b.pos.includes(nr)) return true;
      if (b.praefix && b.praefix.some(p => nr.startsWith(p))) return true;
      if (passtZuGrund(b.grundPos, pp)) return true;
      return false;
    });
  });
}
